import { h, Fragment, } from '@stencil/core';
import { send, documentDownloadEvent, mainDocumentsDropDownEvent, isAnalyticsEnabled, ETabType, EQdsButtonImportance, EQdsButtonSize } from '@pes-ui/utils';
import { isMobile } from '../../../globals/utils';
import { DOCUMENT_ITEM_CLASS, DOCUMENT_ITEM_WRAPPER_CLASS, ACTION_TYPES, ACTION_ICONS_MAP, } from './constants';
export class AssetBar {
  windowSizeDidChange() {
    const currentViewState = isMobile();
    if (this.isMobile !== currentViewState) {
      this.isMobile = currentViewState;
    }
  }
  constructor() {
    this.getDDCDocumentsAvailability = () => {
      return !!window.__STICKYBARSTORE.items.find((item) => item.name === ETabType.DDC_DOCUMENTS);
    };
    this.getDDCSoftwareAvailability = () => {
      return !!window.__STICKYBARSTORE.items.find((item) => item.name === ETabType.DDC_SOFTWARE);
    };
    this.createDropdownContainerRef = (el) => {
      this.dropdownContainerRef = el;
    };
    this.createTooltipContainerRef = (el) => {
      this.tooltipContainerRef = el;
    };
    this.showTooltip = ({ event, files, links, title, documentGroup }) => {
      this.isDDCDocumentsAvailable = this.getDDCDocumentsAvailability();
      const documentItemElement = event.composedPath().find((element) => {
        var _a;
        return (_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(DOCUMENT_ITEM_CLASS);
      });
      if (documentItemElement && files) {
        const { downloadAll, viewOnline, viewOtherFormats } = this.labels;
        this.tooltipContainerDocuments = files;
        this.tooltipContainerLinks = links;
        this.dropdownLabels = { title, downloadAll, viewOnline, viewOtherFormats };
        this.documentGroup = documentGroup;
        this.createTooltipContainerRef(documentItemElement);
        this.isTooltipActive = true;
        if (isAnalyticsEnabled()) {
          const { documentType } = documentGroup;
          send(mainDocumentsDropDownEvent, { mainDocumentType: documentType });
        }
      }
    };
    this.onDocumentDownloadHandler = (document) => {
      if (isAnalyticsEnabled()) {
        const { documentReference: documentId, documentName, documentType } = document;
        send(documentDownloadEvent, { documentId, documentName, documentType });
      }
    };
    this.renderDocumentItemContent = (extension, label, actionIconType) => {
      return (h(Fragment, null, h("pes-document-icon", { class: "document-item__icon-type", type: extension.replace('icon-', '') }), h("div", { class: "document-item__label-with-icon" }, h("span", { class: "document-item__label" }, label), this.renderActionIcon(actionIconType))));
    };
    this.renderDocumentsListItem = (document) => {
      const { type, url, title, extension, files, downloadAll, viewOnline, viewOtherFormats, documentType, documentName, documentReference, } = document;
      const { dropdown } = ACTION_TYPES;
      if (type === dropdown) {
        return (h("div", { class: DOCUMENT_ITEM_WRAPPER_CLASS }, h("div", { class: DOCUMENT_ITEM_CLASS, onClick: (event) => {
            this.showTooltip({
              event,
              files,
              links: {
                downloadAll,
                viewOnline,
                viewOtherFormats,
              },
              title,
              documentGroup: {
                documentType,
                documentName,
                documentReference,
              },
            });
          } }, this.renderDocumentItemContent(extension, title, type))));
      }
      return (h("div", { class: DOCUMENT_ITEM_WRAPPER_CLASS }, h("a", { class: DOCUMENT_ITEM_CLASS, target: "_blank", href: url, rel: "nofollow", onClick: () => this.onDocumentDownloadHandler(document) }, this.renderDocumentItemContent(extension, title, type))));
    };
    this.seeAllDocuments = (event) => {
      event.preventDefault();
      this.scrollToAllDocuments.emit();
    };
    this.seeAllSoftwareAndFirmware = (event) => {
      event.preventDefault();
      this.scrollToSoftwareAndFirmware.emit();
    };
    this.renderFirmwareListItem = () => {
      var _a, _b;
      if (((_a = this.secondaryDocuments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return (h(Fragment, null, h("div", { class: 'asset-bar-firmware-display' }, h("span", { class: "document-heading" }, this.labels.latestFirmwareHeading), (_b = this.secondaryDocuments) === null || _b === void 0 ? void 0 :
          _b.map(this.renderDocumentsListItem), this.isDDCSoftwareAvailable && (h("qds-standalone-link", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, className: "link", onClick: this.seeAllSoftwareAndFirmware }, this.labels.seeAllSoftwareAndFirmware)))));
      }
    };
    this.labels = undefined;
    this.documents = undefined;
    this.secondaryDocuments = undefined;
    this.columnsCount = undefined;
    this.isTooltipActive = false;
    this.isMobile = isMobile();
    this.isDDCDocumentsAvailable = false;
    this.isDDCSoftwareAvailable = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  didCloseDialogHandler() {
    this.isTooltipActive = false;
  }
  clickHandle(event) {
    if (!event.composedPath().includes(this.dropdownContainerRef)) {
      this.isTooltipActive = false;
    }
  }
  handleTabInit() {
    this.isDDCDocumentsAvailable = this.getDDCDocumentsAvailability();
    this.isDDCSoftwareAvailable = this.getDDCSoftwareAvailability();
  }
  renderActionIcon(type) {
    const iconTitle = ACTION_ICONS_MAP[type];
    return iconTitle ? (h("se-icon", { class: "document-item__icon-action", size: this.isMobile ? 'small' : 'nano', rotate: type === ACTION_TYPES.dropdown && 90 }, iconTitle)) : null;
  }
  render() {
    if (!this.documents.length) {
      return null;
    }
    return (h("div", { class: {
        'asset-bar': true,
        [`asset-bar-columns-count-${this.columnsCount}`]: this.columnsCount === 7,
      } }, h("div", { class: {
        'asset-bar-document-heading': true,
        'asset-bar-document-heading--single': this.columnsCount === 1,
      } }, h("div", null, h("span", { class: "document-heading" }, this.labels.documentHeading)), h("div", { class: {
        'asset-bar__documents-list': true,
        [`asset-bar__documents-list--columns-count-${this.columnsCount === 7 ? 1 : this.columnsCount}`]: this.columnsCount === 1 || this.columnsCount === 2 || this.columnsCount === 7,
      } }, this.documents.map(this.renderDocumentsListItem)), h("qds-standalone-link", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, className: "link", onClick: this.seeAllDocuments }, this.labels.seeAllDocuments)), this.renderFirmwareListItem(), this.tooltipContainerRef && (h("pes-document-dropdown", { reference: this.tooltipContainerRef, isActive: this.isTooltipActive, documents: this.tooltipContainerDocuments, labels: this.dropdownLabels, links: this.tooltipContainerLinks, ref: this.createDropdownContainerRef, documentGroup: this.documentGroup }))));
  }
  static get is() { return "pes-asset-bar"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["asset-bar.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["asset-bar.css"]
    };
  }
  static get properties() {
    return {
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TAssetBarLabels",
          "resolved": "{ title: string; downloadAll: string; viewOtherFormats: string; seeAllDocuments: string; seeAllSoftwareAndFirmware: string; latestFirmwareHeading: string; documentHeading: string; viewOnline: string; }",
          "references": {
            "TAssetBarLabels": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with labels"
        }
      },
      "documents": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TAssetBarDocument[]",
          "resolved": "TAssetBarDocument[]",
          "references": {
            "TAssetBarDocument": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with list of documents"
        }
      },
      "secondaryDocuments": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TAssetBarDocument[]",
          "resolved": "TAssetBarDocument[]",
          "references": {
            "TAssetBarDocument": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "columnsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of columns of documents in desktop view"
        },
        "attribute": "columns-count",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "isTooltipActive": {},
      "isMobile": {},
      "isDDCDocumentsAvailable": {},
      "isDDCSoftwareAvailable": {}
    };
  }
  static get events() {
    return [{
        "method": "scrollToAllDocuments",
        "name": "scrollToAllDocuments",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "null",
          "resolved": "null",
          "references": {}
        }
      }, {
        "method": "scrollToSoftwareAndFirmware",
        "name": "scrollToSoftwareAndFirmware",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "null",
          "resolved": "null",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }, {
        "name": "didCloseDialog",
        "method": "didCloseDialogHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "click",
        "method": "clickHandle",
        "target": "document",
        "capture": true,
        "passive": false
      }, {
        "name": "tabInit",
        "method": "handleTabInit",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
